/* eslint-disable global-require */
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row, Image, Container, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import { getCookies } from "../../hooks/useCookies";
import { TableContext } from "../../contexts/tableContext";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import styles from "./ParticipationReqDetailsPopup.module.scss";
import { DateFormatter } from "../../utilityFunctions/utilsFunctions";
import envValues from "../../enviornment";
import { Entry } from "../../redux/entrySlice";
import { useDispatch } from "react-redux";
import { REACT_APP_API_FETCH_PARTICIPATION_REQUESTS_DETAILS } from "../../redux/apiConstants";
import CustomTable from "../../components/CustomTable/CustomTable";
import Loader from '../../components/Loader/Loader';

const ClaimReqDetailsPopup = React.memo(
  ({ data, cafeId, handleClose, setIsUpdated }) => {
    const { dashboardStyle } = useContext(TableContext);
    const { setDashboardHeader } = useContext(TableContext);
    const { bodyStyle } = useContext(TableContext);
    const { formthemeStyle, bodyheader, viewformStyle } =
      useContext(TableContext);
    const dispatch = useDispatch();
    const params = useParams();
    // let claimRequestId;
    const token = `Bearer ${getCookies("Token")}`;
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState([]);
    const [participationDetails, setParticipationDetails] = useState([]);

    const [canDelete, setCanDelete] = useState(true);

    let statusCode;
    const getParticipationDetails = async () => {
      setLoading(true);
      axios
        .get(
          `${REACT_APP_API_FETCH_PARTICIPATION_REQUESTS_DETAILS}/${cafeId}`,
          {
            method: "GET",
            headers: { Authorization: token },
          }
        )
        .then((resp) => {
          statusCode = resp.status;
          return resp.data;
        })
        .then((res) => {
          if (statusCode === 200) {
            console.log("res.data.payout details", res.data.result);
            setParticipationDetails(res.data.result);
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          return err;
        });
    };
    const navigate = useNavigate();
    useEffect(() => {
      window.scrollTo(0, 0);
      //   claimRequestId = params.id;
      getParticipationDetails();
      console.log("first", cafeId);
      setDetails(data);
      // setDashboardHeader("Payout Details");
    }, []);

    const handleReward = async (id) => {
      confirmAlert({
        title: canDelete ? "" : "Oops!!",
        message: "Are you sure you want to reward $100?",
        buttons: canDelete
          ? [
              {
                label: "Yes",
                onClick: () => {
                  const actionData = {};
                  actionData.actionUrl = `cafe/initiate-reward/${id}`;
                  actionData.actionMethod = "post";
                  actionData.apiData = { amount: 50, type: "participation" };
                  dispatch(Entry(actionData))
                    .then((data) => {
                      console.log("Dataa ===", data.payload.data);
                      // setShowTablePopUp(true);
                      // setActionReject((prev) => prev + 1);
                      // toast.success("Duplicate cafe created successfully");
                      setIsUpdated(true);
                      // if (!dashUpdate) {
                      //   setDashUpdate(true);
                      // }
                    })
                    .catch((err) => {
                      toast.error("Error rewarding $100");
                      console.error("Error: ", err);
                    });
                },
              },
              {
                label: "No",
                // onClick: () => alert("Click No")
              },
            ]
          : [
              {
                label: "Ok",
                // onClick: () => alert("Click No")
              },
            ],
      });
    };

    return (
      <div
        className={styles.popupbox}
        // style={{ width: "60%", maxWidth: "800px" }}
      >
        <div className={styles[formthemeStyle]} id={styles.box}>
          <span
            className={styles.closeicon}
            role="button"
            tabIndex={0}
            onClick={handleClose}
            onKeyPress={handleClose}
          >
            <FontAwesomeIcon icon={faTimes} />
          </span>
          {loading ? (
            <Loader centered />
          ) : (
            <Container fluid>
              {/* <FontAwesomeIcon
                icon={faArrowLeft}
                value="Back"
                onClick={() => {
                  navigate(-1);
                }}
                className={styles.arrowback}
              /> */}
              <Row>
                {/* <h5 className={styles[bodyheader]} id={styles.addheading}>
                  Claim Request Details
                </h5> */}
                {/* <Col lg={12}>
                <div className={styles.profilepicdiv}>
                  {details.image ? (
                    <Image
                      src={details.image}
                      alt="logo"
                      className={styles.profilepic}
                    />
                  ) : (
                    <div style={{ minHeight: "20px" }}></div>
                  )}
                </div>
              </Col> */}
              </Row>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  padding: "10px",
                }}
              >
                <h3
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    textAlign: "center",
                    marginBottom: "15px",
                  }}
                >
                  Cafe Participation Requests
                </h3>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "left",
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          borderBottom: "1px solid #ccc",
                          padding: "8px",
                        }}
                      >
                        Name
                      </th>
                      <th
                        style={{
                          borderBottom: "1px solid #ccc",
                          padding: "8px",
                        }}
                      >
                        Email
                      </th>
                      <th
                        style={{
                          borderBottom: "1px solid #ccc",
                          padding: "8px",
                        }}
                      >
                        Requested Date
                      </th>
                      <th
                        style={{
                          borderBottom: "1px solid #ccc",
                          padding: "4px",
                        }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {participationDetails?.map((req, index) => (
                      <tr key={index}>
                        <td style={{ padding: "8px" }}>
                          {req?.user?.name || "-"}
                        </td>
                        <td style={{ padding: "8px" }}>
                          {req?.user?.email || "-"}
                        </td>
                        <td style={{ padding: "8px" }}>
                          {new Date(req?.createdAt).toLocaleDateString()}
                        </td>
                        {!req.rewarded && (
                          <td style={{ padding: "8px" }}>
                            <button
                              className={`${styles.actionbtn} btn btn-outline-success btn-sm mx-3`}
                              onClick={() => handleReward(req?._id || req?.id)}
                            >
                              Reward $50
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Container>
          )}
        </div>
      </div>
    );
  }
);

export default ClaimReqDetailsPopup;
